import { createFileRoute } from '@tanstack/react-router'

export interface AdminTemplateLibrarySearch {
  page?: number
}

export const Route = createFileRoute('/forms/admin')({
  validateSearch: (search: Record<string, unknown>): AdminTemplateLibrarySearch => ({
    page: typeof search.page === 'number' && search.page > 1 ? search.page : undefined,
  }),
})
